<div class="centered-content">
  <div class="pdf-container" *ngIf="this.pdfSrc && !pdfSignedLoaded">
    <pdf-viewer [src]="pdfSrc"
                [render-text]="false"
                [original-size]="false"
                (after-load-complete)="loadComplete($event)"
                (page-rendered)="getEvent($event)"
                (pages-initialized)="pageInitialized($event)"
                [show-all]="false"
                (wheel)="onWheel($event)"
                [page]="page"
                (mousedown)="onMouseDown($event)"
                (mousemove)="onMouseMove($event)"
                (mouseup)="onMouseUp()">
    </pdf-viewer>
    <div class="pdf-navigation">
      <button mat-icon-button (click)="goToFirstPage()">
        <mat-icon>first_page</mat-icon>
      </button>
      <button mat-icon-button (click)="prevPage()">
        <mat-icon>navigate_before</mat-icon>
      </button>
      <button mat-icon-button (click)="nextPage()">
        <mat-icon>navigate_next</mat-icon>
      </button>
      <button mat-icon-button (click)="goToLastPage()">
        <mat-icon>last_page</mat-icon>
      </button>
    </div>
    <svg class="overlay">
      <rect *ngIf="isDrawing || width > 0"
            [attr.x]="rectStartX"
            [attr.y]="rectStartY"
            [attr.width]="width"
            [attr.height]="height"
            fill="none"
            stroke="blue"
            stroke-width="2">
      </rect>
    </svg>
  </div>
</div>

